import z from "zod";
import { TicketSchema } from "./Ticket";

export const VenueTicketSchema = TicketSchema.extend({
  customerName: z.string(),
  ticketEventTitle: z.string(),
});
export type VenueTicket = z.infer<typeof VenueTicketSchema>;

export const VenueTicketsSchema = TicketSchema.extend({});
